import Flickity from 'flickity';
import Axios from 'axios';
import './plugins/gridzy.min.js';
import './plugins/jquery-easing.min.js';
import ModuloBox from './plugins/modulobox.js';
import {Power0, TimelineMax, TweenMax} from 'gsap';
import ScrollMagic from 'scrollmagic';
import {ScrollMagicPluginGsap} from "scrollmagic-plugin-gsap";
import 'bootstrap';
import AOS from 'aos';
import 'aos/dist/aos.css';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

if(document.querySelector('.inner.is-empty')) {
    document.querySelectorAll('.inner.is-empty').forEach((el) => {
        el.parentNode.addEventListener('click', (e) => {
            e.preventDefault();
        })

        el.parentNode.style.cursor = 'default';
    })
}

if(document.querySelector('nav.navbar')) {
    const animateNavLine = (target) => {
        if(window.innerWidth > 991) {
            document.querySelectorAll('nav.navbar li a').forEach(el => el.classList.remove('color-white'));
            if(target) {
                const line       = document.querySelector('nav.navbar .active-bg');
                line.style.width = target.offsetWidth + 'px';
                line.style.left  = target.offsetLeft + 'px';

                target.classList.add('color-white');
            } else {
                const line       = document.querySelector('nav.navbar .active-bg');
                line.style.width = '0';
            }
        }
    }

    document.querySelectorAll('nav.navbar li a').forEach((el) => {
        el.addEventListener('mouseover', (event) => {
            animateNavLine(event.target);
        });
    });

    document.querySelector('nav.navbar').addEventListener('mouseleave', () => {
        const active = document.querySelector('nav.navbar .active');
        if(active) {
            animateNavLine(active);
        } else {
            animateNavLine(null);
        }
    });

    window.addEventListener('load', function() {
        animateNavLine(document.querySelector('nav.navbar .active'));
    });
}

if(document.getElementById('contact-form')) {
    let contactForm = document.getElementById('contact-form');
    contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        let formData = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        let validationAlert = document.getElementById('contact-form-validation');

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('alert-danger');

        document.querySelectorAll('.is-invalid').forEach(el => {
            el.classList.remove('is-invalid');
        });
        document.querySelectorAll('.invalid-feedback').forEach(el => {
            el.classList.add('d-none');
        });

        Axios.post(contactForm.action, formData).then(response => {
            if(response.data.success) {
                validationAlert.innerHTML = response.data.message;
                validationAlert.classList.add('alert-success');
                validationAlert.classList.remove('hidden');

                contactForm.innerHTML = '';

                let items = document.getElementById('intake-form').querySelectorAll(['input', 'textarea', '.g-recaptcha', 'button']);
                for(let item in items) {
                    items[item].parentNode.removeChild(items[item]);
                }
            }
        }).catch(exception => {
            grecaptcha.reset();
            if(exception.response.data.errors) {
                for(let error in exception.response.data.errors) {
                    if(document.querySelector('[name="' + error + '"]')) {
                        let el = document.querySelector('[name="' + error + '"]');
                        el.classList.add('is-invalid');
                        if(el.parentNode.querySelector('.d-none') !== null) {
                            el.parentNode.querySelector('.d-none').classList.remove('d-none');
                        }
                    }
                }
            }
        });
    });
}

(function($) {
    "use strict"; // Start of use strict

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // Calc .upcoming events div height
    $('.row').each(function() {
        var divHeight = $(this).find('.app-screenshot').height();
        $(this).find('.app-screenshot-description').css('height', divHeight + 'px');
    });

    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Parallax header
    $(function() {
        // 	init scrollmagic
        var controller = new ScrollMagic.Controller;

        // 	loop through slides
        $(".parallax").each(function() {

            var bg = $(this).find(".background-image");

            // Add tweenmax for backgroundParallax
            var parallax = TweenMax.to(bg, 1, {
                y:    '-25%',
                ease: Power0.easeNone
            });

            // Create scrollmagic scene
            /*var parallaxScene = new ScrollMagic.Scene({
                triggerElement: this, // <-- Use this to select current element
                triggerHook:    "onEnter",
                duration:       '500%',
            })
                .setTween(parallax)
                .addTo(controller);*/
        });
    });

    // FLICKITY
    var elem = document.querySelector('.carousel');
    if(elem !== null) {
        var flkty = new Flickity(elem, {
            cellAlign:       'left',
            freeScroll:      true,
            wrapAround:      true,
            groupCells:      false,
            draggable:       true,
            prevNextButtons: true,
            pageDots:        false,
        });
    }

    // Icon bulleted lists
    $('ul[data-bullet]').each(function() {
        var bullet = $(this).attr('data-bullet');
        $(this).find('li').prepend('<i class="' + bullet + '"></i>');
    });

    // POPPER / POPOVER
    $(function() {
        $('[data-toggle="popover"]').popover()
    });

    // Gridzy
    $('.gridzy').gridzy({
        spaceBetween:  10,
        desiredHeight: 400
    });

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {
        if(window.cubeRAF) {
            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;
        }
    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {
        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }
    });

    modulobox.init();

    // Offscreen Nav
    if($('.offscreen-toggle').length) {
        $('body').addClass('has-offscreen-nav');
    } else {
        $('body').removeClass('has-offscreen-nav');
    }

    $('.offscreen-toggle').click(function() {
        $('.main-container').toggleClass('reveal-nav');
        $('nav').toggleClass('reveal-nav');
        $('.offscreen-container').toggleClass('reveal-nav');
    });

    $('.main-container').click(function() {
        if($(this).hasClass('reveal-nav')) {
            $(this).removeClass('reveal-nav');
            $('.offscreen-container').removeClass('reveal-nav');
            $('nav').removeClass('reveal-nav');
        }
    });

    $('.offscreen-container a').click(function() {
        $('.offscreen-container').removeClass('reveal-nav');
        $('.main-container').removeClass('reveal-nav');
        $('nav').removeClass('reveal-nav');
    });

    // Init tooltips
    $(function() {
        $('[data-toggle="tooltip"]').tooltip()
    })

    // Change logo height on scroll
    var navbarCollapse = function() {
        if($("#scroll-indicator").offset().top > 1) {
            $(".logo").addClass("logo-shrink");
        } else {
            $(".logo").removeClass("logo-shrink");
        }
    };
    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

})($); // End of use strict
